import React from 'react'
import PropTypes from 'prop-types'
import styles from './_privacyStyles.css'

function FinePrint (props) {
  const { children } = props

  return (<div className={styles.finePrint}>{ children }</div>)
}

FinePrint.propTypes = {
  children: PropTypes.object,
}

export default FinePrint
